import ImeiHubServicePhosphorIcon, { type ImeiHubServiceId } from './imeiHubServicePhosphorIcon'

export type { ImeiHubServiceId }

type Props = {
  service: ImeiHubServiceId
}

export default function ImeiHubSignalIcon({ service }: Props) {
  return (
    <span className="vc-imei-hub__signal" aria-hidden="true">
      <ImeiHubServicePhosphorIcon service={service} size={22} weight="regular" />
    </span>
  )
}
